import { render, staticRenderFns } from "./addClass.vue?vue&type=template&id=2b4f375f&scoped=true&"
import script from "./addClass.vue?vue&type=script&lang=js&"
export * from "./addClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4f375f",
  null
  
)

export default component.exports